export default __webpack_public_path__ + "static/media/FOTO5.d815ed5e.jpg";